module.exports = __webpack_public_path__ + "img/aghk-train-default.367a01ec.svg";